

import { Box, Drawer, styled, useTheme } from '@mui/material';
import { FC, useContext } from 'react';

import MapFormContext from '../../contexts/data/MapFormContext';
import SpeciesFormBase from '../forms/SpeciesFormBase';
import ViewHistory from '../forms/ViewHistory';


const SpacingBox = styled(Box)(({ theme }) => ({
    ...theme.mixins.toolbar,
    height: 75
}));

const MapFormDrawer: FC = () => {

    //
    // -- Hooks --
    const theme = useTheme();

    //
    // -- Contexts -- 
    const { drawerOpen, closeDrawer, viewHistoryRoot, drawerMaximised } = useContext(MapFormContext);

    return (
        <Drawer
            anchor="left"
            open={drawerOpen && drawerMaximised}
            onClose={closeDrawer}
            hideBackdrop
            variant="persistent"
            sx={{
                width: '400px',
                [theme.breakpoints.down('lg')]: {
                    width: '100%',
                },
                flexShrink: 0,
                '&.MuiDrawer-docked': {
                    width: '0px !important'
                },
                '& .MuiDrawer-paper': {
                    width: '400px',
                    [theme.breakpoints.down('lg')]: {
                        width: '100%',
                    },
                    boxSizing: 'border-box',
                    backgroundColor: viewHistoryRoot ? '#ededed' : 'white',
                }
            }}
        >
            <SpacingBox />

            {
                viewHistoryRoot
                    ? 
                        <ViewHistory /> 
                    : 
                        <SpeciesFormBase /> 
            }
            
        </Drawer>
    );
}

export default MapFormDrawer